export default {
    getId: (item) => {
        return item["id"]
    },
    getName: (item) => {
        return item["name"]
    },
}
